import { createApi } from '@reduxjs/toolkit/query/react';

import type { AuditLogFilterParams } from '@features/audit-log/schemas/audit-log-filter.schema';
import { fetchBaseQueryWithTokenCheck } from '@shared/utils/api.utils';

import type { AuditLogsResponse } from './audit-log.types';

export const auditLogApiSlice = createApi({
  reducerPath: 'auditLogApi',
  baseQuery: fetchBaseQueryWithTokenCheck,
  endpoints: (builder) => ({
    getAuditLogs: builder.query<AuditLogsResponse, AuditLogFilterParams>({
      query: ({ ...params }) => {
        return {
          url: `/api/v1/audittrail`,
          params,
        };
      },
    }),
    getAuditUsers: builder.query<string[], void>({
      query: () => {
        return {
          url: `/api/v1/audittrail/users`,
        };
      },
    }),
  }),
});

export const { useLazyGetAuditLogsQuery, useGetAuditUsersQuery } = auditLogApiSlice;
